export default "__VITE_ASSET__DRhC9zGT__"